
import { mapGetters, mapActions } from 'vuex'
export default {
	components: {
		breadcrumbs		: () => import('../../components/pages/breadcrumbs.vue'),
        vcFormField		: () => import("../../components/pages/form-field.vue"),
		vcDynamicLink	: () => import('../../components/pages/dynamic-link.vue')
	},
	data() {
		return {
			login_user		: {
				email	: '',
				password: ''
			},
			availableLogin	: false
		}
	},
	mounted(){
		this.$root.$on('update-field-value', this.updateFieldValue);
		if ( this.getterLogin ) {
			
			this.$router.push('/');
		}
	},
	computed: {
		...mapGetters({
            getterTranslates	: 'getterTranslates',
            getterStoreLang		: 'getterStoreLang',
			getterLogin			: 'getterLogin',
			getterUser			: 'getterUser',
			getterProfileImage	: 'getterProfileImage',
			getterNotification	: 'getterNotification'
		}),
		getLoginUser(){
			return this.login_user;
		},
		isAvailableLogin(){
			return this.availableLogin;
		}
	},
	methods: {
		...mapActions({
			loginUser: 'loginUser'
		}),
		updateFieldValue(data){
            this.login_user[data.field] = data.value;
		},
		async onSubmit() {
			if(this.getLoginUser.email.trim() != '' && this.getLoginUser.password.trim() != '') {
				this.availableLogin = true;
				await this.loginUser({ email: this.getLoginUser.email, password: this.getLoginUser.password }).then( (result_user) => {
					
					this.availableLogin = false;
					if(this.getterUser){
						
						this.login_user.email = '';
						this.login_user.password = '';
						this.$root.$emit('update-profile-image', this.getterProfileImage);
						this.$root.$emit('login-user', true);
						this.$router.replace('/');
					}
				});
			}
		},
	}
}
